import { Button as CarbonButton, ButtonProps } from '@carbon/react';
import React, { ElementType } from 'react';

export const Button = <T extends ElementType>(props: ButtonProps<T>) => (
  <CarbonButton {...props} />
);

Button.displayName = 'Button';
